<template>
  <div>
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'General Ledger - Headings & Totals' }"
      >
        Headings & Totals
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - Collateral Bank' }"
      >
      Collateral Bank
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'GLBrowse',
  components: {
  },
};
</script>
